import { render } from "./postcodeSearch.html?vue&type=template&id=47d1afb2&scoped=true&ts=true&external"
import script from "./postcodeSearch.ts?vue&type=script&lang=ts&external"
export * from "./postcodeSearch.ts?vue&type=script&lang=ts&external"

import "./postcodeSearch.scss?vue&type=style&index=0&id=47d1afb2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d1afb2"]])

export default __exports__